


























































































































import {Utils} from '@/utils/Utils.ts';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {API} from '@/services/api/api';
import VuePassword from 'vue-password';
import {mapActions} from 'vuex';
import {redirectTime} from '@/constants/constants';

@Component({
  components: {VuePassword},
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class ChangePassword extends Vue {
  mounted() {
    this.userId = Number.parseInt(this.$route.params.id);
  }
  //store variables
  showSuccessToast: any;
  showErrorToast: any;

  //form variables
  newPassword = '';
  confirmPassword = '';
  passStrength: number = 0;
  showPass = false;
  userId: any = null;
  formTitle = 'Change Password';

  // validation variables
  isPasswordMatched: any = null;
  passwordValidationMsg: any = null;
  confirmPasswordValidationMsg: any = null;
  onNullErrorMsg = 'This field is required.';

  //loader variable
  loadingBtnStatus = false;

  validatePassword() {
    if (this.newPassword.length < 1 || this.newPassword === '') {
      this.passwordValidationMsg = this.onNullErrorMsg;
      return false;
    } else if (!Utils.validatePassword(this.newPassword)) {
      this.passwordValidationMsg =
        'Password must be 8-20 characters , must include at least one: uppercase letter, lowercase letter, number & special character';
      return false;
    } else {
      this.passwordValidationMsg = '';
      return true;
    }
  }

  validateConfirmPassword() {
    if (this.confirmPassword === '' || this.confirmPassword.length < 1) {
      this.confirmPasswordValidationMsg = this.onNullErrorMsg;
      return false;
    } else if (this.newPassword !== this.confirmPassword) {
      this.confirmPasswordValidationMsg = 'Password and confirm password does not match';
      return (this.isPasswordMatched = false);
    } else {
      this.confirmPasswordValidationMsg = 'Password and confirm password matched';
      return (this.isPasswordMatched = true);
    }
  }

  validateAll() {
    return this.validatePassword() && this.validateConfirmPassword();
  }

  //check password length and show password-meter based upon it
  @Watch('newPassword') //only 1-4 pass strength
  onPassChange(pass: string, oldPass: string) {
    this.passStrength = Utils.calculatePassStrength(pass);
  }

  //submit button handler
  public async _changePasswordHandler() {
    if (!this.validateAll()) {
      return;
    }
    try {
      this.loadingBtnStatus = true;
      let response = await API.changePassword(this.userId, this.newPassword);
      this.loadingBtnStatus = false;

      if (response.data) {
        let message: string = response.message;
        if (message.includes('Password has been changed')) {
          message = 'Record updated successfully';
        }
        this.showSuccessToast({msg: message});

        setTimeout(() => this.$router.go(-1), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.loadingBtnStatus = false;

      this.showErrorToast({msg: 'Network error'});
    }
  }

  //toggle password visibility
  togglePassword() {
    this.showPass = !this.showPass;
  }
}
